import React, {useMemo} from 'react';
import {usePosition} from "../../../providers/ProjectPositionProvider";
import ProjectPosition from "../../../models/ProjectPosition";
import User from "../../../models/User";
import {useAuth} from "../../../providers/AuthProvider";

const ChangeOrderItemImpactPanel = ({item, ...props}) => {
    const {auth} = useAuth();
    const canManageClients = auth.canManageClients();

    const {position} = usePosition();
    const lastCandidateSegment = useMemo(() => {

        if (item.id) {
            return {
                total_periods: item.original_total_periods,
                platform_cost: item.original_platform_cost,
                talent_cost: item.original_talent_cost,
                platform_fee: item.original_platform_cost - item.original_talent_cost,
                ended_at: item.original_ended_at,
                rate: item.original_rate,
                platform_rate: item.original_platform_rate,
            }
        }
        let segment = TB.last(position.candidate_segments);
        segment.platform_fee = segment.platform_cost - segment.talent_cost;
        segment.candidate.user = User.make(segment.candidate.user)
        return segment;
    }, [position]);

    const hourImpact = useMemo(() => {
        if (item.id) {
            return item.new_total_periods - item.original_total_periods;
        }

        switch (item.type) {
            case ProjectPosition.ChangeOrderTypes.TypeTimeline:
                return item.total_periods - lastCandidateSegment.total_periods
            case ProjectPosition.ChangeOrderTypes.TypeRate:
                return (item.last_segment_periods - item.total_periods) + item.affected_periods;
            case ProjectPosition.ChangeOrderTypes.TypeCandidate:
                return (item.last_segment_periods - item.total_periods) + item.affected_periods;
        }
    }, [
        item.type,
        item.total_periods,
        lastCandidateSegment.total_periods,
        item.affected_periods,
        item.last_segment_periods
    ]);
    const resourceCostImpact = useMemo(() => {
        if (item.id) {
            return Number(item.net_talent_cost).toFixed(2)
        }
        return Number(item.talent_cost - lastCandidateSegment.talent_cost).toFixed(2)
    }, [
        item.type,
        item.talent_cost,
        lastCandidateSegment.talent_cost,
    ]);
    const clientFeetImpact = useMemo(() => {
        if (item.id) {
            return Number(item.net_contract_value).toFixed(2)
        }
        return Number(item.platform_cost - lastCandidateSegment.platform_cost).toFixed(2)
    }, [
        item.type,
        item.platform_cost,
        lastCandidateSegment.platform_cost,
    ]);
    return (
        <div className="bg-wrippleOffWhite p-3 w-full h-fit">


            <div className="flex flex-col gap-2 pb-2">
                <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue">
                    Contract Changes
                </p>

                {item.type === ProjectPosition.ChangeOrderTypes.TypeTimeline && (
                    <React.Fragment>
                        <div className="flex items-center justify-between">
                            <p>End Date</p>
                            <p className="flex gap-2 text-xs">
                                {!TB.moment(lastCandidateSegment.ended_at).isSame(item.ended_at, 'day') && (
                                    <React.Fragment>
                                        <span className="text-red-400 line-through">
                                            {TB.moment(lastCandidateSegment.ended_at).format('MM/DD/YYYY')}
                                        </span>
                                        <i className="fas fa-arrow-right"/>
                                    </React.Fragment>
                                )}
                                {TB.moment(item.ended_at).format('MM/DD/YYYY')}
                            </p>
                        </div>
                        <div className="flex items-center justify-between">
                            <p>Total Hours</p>
                            <p className="flex gap-2 text-xs">
                                {(lastCandidateSegment.total_periods) !== item.total_periods && (
                                    <React.Fragment>
                                        <span className="text-red-400 line-through">
                                            {lastCandidateSegment.total_periods}
                                        </span>
                                        <i className="fas fa-arrow-right"/>
                                    </React.Fragment>
                                )}
                                {item.total_periods} hrs
                            </p>
                        </div>


                    </React.Fragment>
                )}

                {(item.type === ProjectPosition.ChangeOrderTypes.TypeRate || item.type === ProjectPosition.ChangeOrderTypes.TypeCandidate) && (
                    <React.Fragment>
                        <div className="flex items-center justify-between">
                            <p>End Date</p>
                            <p className="flex gap-2 text-xs">
                                {!TB.moment(lastCandidateSegment.ended_at).isSame(item.ended_at, 'day') && (
                                    <React.Fragment>
                                        <span className="text-red-400 line-through">
                                            {TB.moment(lastCandidateSegment.ended_at).format('MM/DD/YYYY')}
                                        </span>
                                        <i className="fas fa-arrow-right"/>
                                    </React.Fragment>
                                )}
                                {TB.moment(item.ended_at).format('MM/DD/YYYY')}
                            </p>
                        </div>
                        {canManageClients &&  (
                            <div className="flex items-center justify-between">
                                <p>Talent Rate</p>
                                <p className="flex gap-2 text-xs">
                                    {Number(lastCandidateSegment.rate).toFixed(2) !== Number(item.rate)
                                        .toFixed(2) && (
                                        <React.Fragment>
                                            <span className="text-red-400 line-through">
                                                ${Number(lastCandidateSegment.rate).toFixed(2)}/hr
                                            </span>
                                            <i className="fas fa-arrow-right"/>
                                        </React.Fragment>
                                    )}
                                    ${Number(item.rate).toFixed(2)}/hr
                                </p>
                            </div>
                        )}
                        <div className="flex items-center justify-between">
                            <p>Bill Rate</p>
                            <p className="flex gap-2 text-xs">
                                {Number(lastCandidateSegment.platform_rate).toFixed(2) !== Number(item.platform_rate)
                                    .toFixed(2) && (
                                    <React.Fragment>
                                        <span className="text-red-400 line-through">
                                            ${Number(lastCandidateSegment.platform_rate).toFixed(2)}/hr
                                        </span>
                                        <i className="fas fa-arrow-right"/>
                                    </React.Fragment>
                                )}
                                ${Number(item.platform_rate).toFixed(2)}/hr
                            </p>
                        </div>
                        <div className="flex items-center justify-between">
                            <p>Total Hours</p>
                            <p className="flex gap-2 text-xs">
                                {hourImpact !== 0 && (
                                    <React.Fragment>
                                        <span className="text-red-400 line-through">
                                            {lastCandidateSegment.total_periods}
                                        </span>
                                        <i className="fas fa-arrow-right"/>
                                    </React.Fragment>
                                )}
                                {lastCandidateSegment.total_periods + hourImpact} hrs
                            </p>
                        </div>
                    </React.Fragment>
                )}
            </div>
            <div className="flex flex-col gap-2 pb-2 mt-3">
                <p className="text-sm font-medium text-left text-wripplePrimaryLightBlue">
                    Change Order Impact
                </p>
                <div className="flex items-center justify-between border-t border-wripplePrimaryRuleBlue pt-3">
                    <p>Hour Impact</p>
                    <p className={"font-medium text-base " + (hourImpact >= 0 ? '' : 'text-danger')}>
                        {hourImpact >= 0 ? '+' : '-'} {Math.abs(hourImpact)} hours
                    </p>
                </div>
                {canManageClients &&  (
                    <div className="flex items-center justify-between border-t border-wripplePrimaryRuleBlue pt-3">
                        <p>Resource Cost Impact</p>
                        <p className={"font-medium text-base " + (resourceCostImpact >= 0 ? '' : 'text-danger')}>
                            ${TB.formatNumber(resourceCostImpact, 2)}
                        </p>
                    </div>
                )}
                <div className="flex items-center justify-between border-t border-wripplePrimaryRuleBlue pt-3">
                    <p>{canManageClients ? "Client Fee Impact" : "Contract Value Impact"}</p>
                    <p className={"font-medium text-base " + (clientFeetImpact >= 0 ? '' : 'text-danger')}>
                        ${TB.formatNumber(clientFeetImpact, 2)}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ChangeOrderItemImpactPanel;